import { Injectable } from '@angular/core';
import {
  convertToHEXFormat,
  convertToRGBNumbersAlphaFormat,
  convertToRGBNumbersFormat,
  darkenColor,
  lightenColor,
  parseRgb,
} from '@utils/color';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  setTheme(theme: string, color?: string) {
    document.body.dataset['theme'] = theme;
    this.updateCSSVariables(theme, color ?? null);
  }

  private updateCSSVariables(theme: string, color: string | null) {
    const root = document.documentElement;
    if (theme === 'custom' && color) {
      const primaryRGB = convertToRGBNumbersFormat(color);
      root.style.setProperty('--color-primary', primaryRGB);
      if (primaryRGB) {
        const primaryLightRGB = lightenColor(
          [
            parseRgb(primaryRGB).r,
            parseRgb(primaryRGB).g,
            parseRgb(primaryRGB).b,
          ],
          0.5
        );
        root.style.setProperty(
          '--color-primary-light',
          primaryLightRGB.join(' ')
        );
        const primaryDarkRGB = darkenColor(
          [
            parseRgb(primaryRGB).r,
            parseRgb(primaryRGB).g,
            parseRgb(primaryRGB).b,
          ],
          0.2
        );
        root.style.setProperty(
          '--color-primary-dark',
          primaryDarkRGB.join(' ')
        );
      }
      root.style.setProperty(
        '--abb-color-primary-hex',
        convertToHEXFormat(color)
      );
    } else {
      root.style.removeProperty('--color-primary');
      root.style.removeProperty('--color-primary-light');
      root.style.removeProperty('--color-primary-dark');
      root.style.removeProperty('--abb-color-primary-hex');
    }
  }

  setTextColor(theme: string, color?: string) {
    this.updateTextCSSVariables(theme, color ?? null);
  }

  private updateTextCSSVariables(theme: string, color: string | null) {
    const root = document.documentElement;
    if (theme === 'custom' && color) {
      const convertedValue = convertToRGBNumbersAlphaFormat(color);
      if (convertedValue) {
        const rgb = convertedValue.rgb;
        const alpha = convertedValue.alpha;
        root.style.setProperty('--base-value-color-font', rgb);
        root.style.setProperty('--alpha-value-color-font', alpha);
        root.style.setProperty(
          '--abb-color-font-hex',
          convertToHEXFormat(color)
        );
      }
    } else {
      root.style.removeProperty('--base-value-color-font');
      root.style.removeProperty('--alpha-value-color-font');
      root.style.removeProperty('--abb-color-font-hex');
    }
  }

  setBackgroundColor(theme: string, color?: string) {
    this.updateBackgroundCSSVariables(theme, color ?? null);
  }

  private updateBackgroundCSSVariables(theme: string, color: string | null) {
    const root = document.documentElement;
    if (theme === 'custom' && color) {
      const convertedValue = convertToRGBNumbersAlphaFormat(color);
      if (convertedValue) {
        const rgb = convertedValue.rgb;
        const alpha = convertedValue.alpha;
        root.style.setProperty('--base-value-color-background', rgb);
        root.style.setProperty('--alpha-value-color-background', alpha);
      }
    } else {
      root.style.removeProperty('--base-value-color-background');
      root.style.removeProperty('--alpha-value-color-background');
    }
  }
}
